import { useMutation } from 'react-query';
import { registratorMessage } from '../api/registrator';

export const useRegister = () => {
    return useMutation(registratorMessage);
};
